export default __webpack_public_path__ + "static/char-47-anr-8aabebbf749a6d09bad2cfec3b786871.webp";